import React from 'react';
import propTypes from 'prop-types';
import BrandLogo from 'tailwind-components/BrandLogo/BrandLogo';

/**
 * empty state for the right-hand panel of the carrier views
 * @param text - message shown under the logo
 */
export default function HiddenSideSection({ text = '' }) {
  return (
    <section className='grow border-2 border-dashed border-grey-lighter rounded-[10px] flex flex-col items-center justify-center h-full w-full relative'>
      <BrandLogo
        variant='fullLogoGrayScale'
        alt=''
        className='w-[250px] grayscale'
        // the bundled mark is wide, an agency logo may be tall, so cap the height too
        agencyClassName='w-auto max-w-[250px] max-h-[120px]'
      />
      <div className='w-[300px] text-center text-grey-light font-medium mt-5'>
        {text ? text : 'Select a carrier on the left to see resources details'}
      </div>
    </section>
  );
}

HiddenSideSection.propTypes = {
  text: propTypes.string
};
